import './vue'

import flatpickr from 'flatpickr'
import '@shat/stylenames'

import './live/registration'
import './live/page'
import './modules/fileUploader'
import './modules/only-integer'
import './modules/livewire-reload'
import './sentry'

import './live/bootstrap'

window.onload = () => {
    flatpickr('.date-picker')

}

import './app/bootstrap'

